import script from "./HumanResource.vue?vue&type=script&setup=true&lang=js"
export * from "./HumanResource.vue?vue&type=script&setup=true&lang=js"

import "./HumanResource.vue?vue&type=style&index=0&id=89ee908a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89ee908a"]])

export default __exports__